"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
var react_1 = require("react");
var useIsomorphicLayoutEffect_1 = require("@r1-frontend/shared/hooks/useIsomorphicLayoutEffect");
var useResizeObserver = function (ref, callback) {
    var _a = __read((0, react_1.useState)(), 2), width = _a[0], setWidth = _a[1];
    var _b = __read((0, react_1.useState)(), 2), height = _b[0], setHeight = _b[1];
    var handleResize = (0, react_1.useCallback)(function (entries) {
        if (!Array.isArray(entries)) {
            return;
        }
        var entry = entries[0];
        setWidth(entry.contentRect.width);
        setHeight(entry.contentRect.height);
        if (callback) {
            callback(entry.contentRect);
        }
    }, [callback]);
    (0, useIsomorphicLayoutEffect_1.useIsomorphicLayoutEffect)(function () {
        if (!ref.current) {
            return;
        }
        var RO = new ResizeObserver(function (entries) { return window.requestAnimationFrame(function () { return handleResize(entries); }); });
        RO.observe(ref.current);
        return function () {
            RO === null || RO === void 0 ? void 0 : RO.disconnect();
            RO = null;
        };
    }, [ref]);
    return { width: width, height: height };
};
exports.useResizeObserver = useResizeObserver;
